module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.state.violations.length) { ;
__p += '\n<div class="pz-alert alert alert-danger clearfix" role="alert">\n    <div class="triangle-icon"><i class="far fa-exclamation-triangle"></i></div>\n    <div class="alert-message">' +
((__t = ( data.state.violations.join("<br/><br/>") )) == null ? '' : __t) +
'</div>\n</div>\n';
 } ;
__p += '\n\n<form class="form-horizontal">\n    <div class="form-group">\n        <div class="col-sm-offset-2 col-sm-10">\n            <div class="save-to-type">\n                <input type="radio" name="saveto" id="saveNewFilter" value="new" ' +
((__t = ( data.state.saveToNewFilter && "checked='checked'" )) == null ? '' : __t) +
'>\n                <label for="saveNewFilter">' +
((__t = ( strings.saveNewFilter )) == null ? '' : __t) +
'</label>\n            </div>\n            <div class="save-to-type ' +
((__t = ( !data.hasFilters && "disabled" )) == null ? '' : __t) +
'">\n                <input type="radio" name="saveto" id="updateExistingFilter" value="existing" ' +
((__t = ( !data.state.saveToNewFilter && "checked='checked'" )) == null ? '' : __t) +
' ' +
((__t = ( !data.hasFilters && "disabled='disabled'" )) == null ? '' : __t) +
'>\n                <label for="updateExistingFilter">' +
((__t = ( strings.updateExistingFilter )) == null ? '' : __t) +
'</label>\n            </div>\n        </div>\n    </div>\n    <div class="form-group">\n        <label for="name" class="col-sm-2 control-label">Name</label>\n        <div class="col-sm-10 ' +
((__t = (data.stateClass)) == null ? '' : __t) +
'">\n            <div class="existing-filters"></div>\n            <input type="text" class="form-control name-input" placeholder="' +
((__t = ( strings.filterNamePlaceholder )) == null ? '' : __t) +
'" id="name" value="' +
((__t = ( data.name )) == null ? '' : __t) +
'" ' +
((__t = ( !data.state.saveToNewFilter && "disabled='disabled'" )) == null ? '' : __t) +
'>\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-sm-2 control-label">Filters</label>\n        <div class="col-sm-10 filters">\n            ';
 data.qualifiers.forEach(function(t) { ;
__p += '\n            <div class="token tooltipped tooltipped-n" aria-label="' +
__e( t.value ) +
'">\n                <span class="operator">\n                    ';
 if (t.operator === "=") { ;
__p += '\n                    <i class="far fa-plus included-icon" aria-hidden="true"></i>\n                    ';
 } else if (t.operator === "!=") { ;
__p += '\n                    <i class="far fa-minus excluded-icon" aria-hidden="true"></i>\n                    ';
 } ;
__p += '\n                </span>\n                <span class="token-label">' +
((__t = ( t.label )) == null ? '' : __t) +
'</span>\n            </div>\n            ';
 }) ;
__p += '\n        </div>\n    </div>\n</form>\n';
return __p
}